<template>
  <hit-select
    :label="t('hit-app.printer-configuration.select-layout')"
    :label-fields="['name']"
    :full-width="true"
    :options="printLayouts"
    :value="value"
    :row-label="false"
    :clearable="false"
    @change="onChange"
  />
</template>

<script>
import {useI18n} from 'vue-i18n';
import {HitInputMixin, HitSelect} from '@hit/components';
import {DataService} from '@hit/base';

export default {
  name: 'HitAppInputPrintLayout',
  components: {HitSelect},
  mixins: [HitInputMixin],
  props: {
    /**
     * Selected value of the template select
     */
    value: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * Label of the template select
     */
    label: {
      type: String,
      default: null,
    },
    template: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      printLayouts: [],
    };
  },
  setup() {
    const {t} = useI18n();
    return {t};
  },
  async beforeMount() {
    const layoutData = await DataService.read('config', {
      attributes: 'id,name',
      filters: {label: 'eq.report.layout'},
    });
    this.printLayouts = layoutData.data;
    if (!this.value) {
      this.fireInputChange(this.printLayouts[0].id);
    }
  },
  methods: {
    onChange(value) {
      this.fireInputChange(value);
    },
  },
};
</script>

<style scoped lang="scss"></style>
